export default {
  accountManagementTable: {
    agency: "Agency",
    name: "Company Name",
    email: "Contact Email",
    country: "Country",
    remarks: "Remarks",
    actions: "Actions",
  },

  advertiserManagementTable: {
    name: "Advertiser Name",
    clientStatus: "Client Status",
    locationDimension: "Location Dimension",
    dmaCount: "# of DMAs",
    yearsActive: "Years Active",
    lastUpdated: "Last Updated",
    industry: "Industry",
    subIndustry: "Sub Industry",
    profileType: "Profile Type",
    averageOrderValue: "Average Order Value",
    audienceSize: "Estimated Audience Size",
    pixelExperience: "Pixeling Experience",
    conversionExperience: "Website Conversion Experience",
    brandRecognition: "Brand Recognition",
    ratingDate: "Date of Rating",
    website: "Website URL",
    actions: "Actions",
  },

  userManagementTable: {
    name: "Display Name",
    email: "Email Address",
    account: "Account",
    role: "Role",
    actions: "Actions",
  },
  templateLibrary: {
    templateName: "Template Name",
    createdBy: "Created By",
    dateUpdated: "Last Date Updated",
    actions: "Actions",
  },
  glossary: {
    calculatedConversion: "Calculated Conversion",
    definition: "Definition",
    associatedCampaignKpi: "Associated Campaign KPI",
  },
};
